/**
 * TYPES
 */
import {IContactPatch} from 'src/aggregates/customers/mutations.d';
import {IContact} from 'src/aggregates/customers/state.d';
import {ICustomerAgent} from 'src/aggregates/customers/state.d';
import {ICustomerTag as ICustomerTagData}
    from 'src/aggregates/customers/state.d';
import {_aggregates} from 'src/aggregates/index.d';
import {ICommand} from 'src/aggregates/index.d';


/**
 * EXPORTS
 */

/**
 * Commands names.
 */
export enum _names
{
    CUSTOMER_ADD = 'CUSTOMER_ADD',
    CUSTOMER_ADD_SEARCH_TERM = 'CUSTOMER_ADD_SEARCH_TERM',
    CUSTOMER_BLOCK_WHATSAPP_CONTACT = 'CUSTOMER_BLOCK_WHATSAPP_CONTACT',
    CUSTOMER_CREATE = 'CUSTOMER_CREATE',
    CUSTOMER_DROP_SIBLINGS = 'CUSTOMER_DROP_SIBLINGS',
    CUSTOMER_FETCH = 'CUSTOMER_FETCH',
    CUSTOMER_FETCH_BY_TAG_PAGE = 'CUSTOMER_FETCH_BY_TAG_PAGE',
    CUSTOMER_FETCH_CONTACT_TYPES = 'CUSTOMER_FETCH_CONTACT_TYPES',
    CUSTOMER_FOCUS = 'CUSTOMER_FOCUS',
    CUSTOMER_FOCUS_CONTACT_BY_UID = 'CUSTOMER_FOCUS_CONTACT_BY_UID',
    CUSTOMER_LOAD_PAGE = 'CUSTOMER_LOAD_PAGE',
    CUSTOMER_LOAD_SIBLINGS = 'CUSTOMER_LOAD_SIBLINGS',
    CUSTOMER_MODIFY = 'CUSTOMER_MODIFY',
    CUSTOMER_REMOVE = 'CUSTOMER_REMOVE',
    CUSTOMER_UPDATE = 'CUSTOMER_UPDATE',
    CUSTOMER_RESET_ERROR = 'CUSTOMER_RESET_ERROR',
    CUSTOMER_TAG = 'CUSTOMER_TAG',
    CUSTOMER_UNBLOCK_WHATSAPP_CONTACT = 'CUSTOMER_UNBLOCK_WHATSAPP_CONTACT',
    CUSTOMER_UNTAG = 'CUSTOMER_UNTAG',
    CUSTOMER_UPDATE_TAGS_FILTER = 'CUSTOMER_UPDATE_TAGS_FILTER',
}


/**
 * Commands interfaces.
 */
export interface ICustomerAdd extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_ADD;
    _target: number | string;
    address1?: string;
    address2?: string;
    agents: ICustomerAgent[];
    city?: string;
    code?: string;
    contacts: IContact[];
    description?: string;
    document?: string;
    email?: string;
    name: string;
    organization?: string;
    state?: string;
    tags?: ICustomerTagData[];
    unassociated: boolean;
    zipcode?: string;
}

export interface ICustomerAddSearchTerm extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_ADD_SEARCH_TERM;
    term: string;
}

export interface ICustomerBlockWhatsappContact extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_BLOCK_WHATSAPP_CONTACT;
    account: string;
    contact: string;
}

export interface ICustomerCreate extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_CREATE;
    address1?: string;
    address2?: string;
    city?: string;
    code?: string;
    company: number;
    contacts: IContact[];
    document?: string;
    name: string;
    description?: string;
    organization?: string;
    state?: string;
    zipcode?: string;
}

export interface ICustomerDropSiblings extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_DROP_SIBLINGS;
    _target: IContact['id'];
}

export interface ICustomerFetch extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_FETCH;
}

export interface ICustomerFetchContactTypes extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_FETCH_CONTACT_TYPES;
}

export interface ICustomerFocus extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_FOCUS;
    customer: string | number | null;
}

export interface ICustomerFetchByTagPage extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_FETCH_BY_TAG_PAGE;
    tag: number;
}

export interface ICustomerLoadPage extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_LOAD_PAGE;
}

export interface ICustomerLoadSiblings extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_LOAD_SIBLINGS;
    _target: IContact['id'];
    typeId: number;
    uid: string;
}

export interface ICustomerModify extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_MODIFY;
    _target: number | string;
    address1: string;
    address2: string;
    agents: ICustomerAgent[];
    city: string;
    code: string;
    contacts: IContact[];
    document: string;
    name: string;
    state: string;
    description: string;
    organization: string;
    tags?: ICustomerTagData[];
    zipcode: string;
}

export interface ICustomerRemove extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_REMOVE;
}

export interface ICustomerUpdate extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_UPDATE;
    address1?: string;
    address2?: string;
    agents: string[];
    city?: string;
    code: string;
    company?: number;
    contacts: IContactPatch[];
    document: string;
    ensureUniqueContacts: boolean;
    name?: string;
    state: string;
    description: string;
    organization?: string;
    zipcode?: string;
}

export interface ICustomerResetError extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_RESET_ERROR;
}

export interface ICustomerTag extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_TAG;
    tag: number;
}

export interface ICustomerUnblockWhatsappContact extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_UNBLOCK_WHATSAPP_CONTACT;
    account: string;
    contact: string;
}

export interface ICustomerUntag extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_UNTAG,
    customerTag: number;
}

export interface ICustomerUpdateTagsFilter extends ICommand
{
    _aggregate: _aggregates.CUSTOMERS;
    _name: _names.CUSTOMER_UPDATE_TAGS_FILTER,
    tags: number[];
}
